/**
 * La data di oggi in Italia, nel formato yyyy-MM-dd.
 *
 * `new Date().toISOString()` restituisce la data di Londra (UTC): fra le 22 e
 * mezzanotte italiana e' ancora ieri. Su una fattura o su un periodo di
 * abbonamento quel giorno di differenza conta.
 */
export const oggiRoma = (adesso: Date = new Date()): string =>
    new Intl.DateTimeFormat('en-CA', {
        timeZone: 'Europe/Rome',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).format(adesso);
